export const resolveContactAvatar = (contact) => {
  try {
    const url = contact?.urlPicture || contact?.profilePicUrl || "";
    if (typeof url === "string" && url.trim() !== "") {
      // ✅ Filtrar URLs inválidas que contêm "null" ou "undefined"
      const trimmedUrl = url.trim();
      if (trimmedUrl.includes('/null') || trimmedUrl.includes('/undefined') || 
          trimmedUrl === 'null' || trimmedUrl === 'undefined' ||
          trimmedUrl.startsWith('null') || trimmedUrl.startsWith('undefined')) {
        return "/nopicture.png";
      }
      return url;
    }
  } catch (e) {
    // noop
  }
  return "/nopicture.png";
};

export const hasCustomAvatar = (contact) => {
  const url = resolveContactAvatar(contact);
  if (!url) return false;
  return !(url.includes("nopicture.png") || url.endsWith("/nopicture.png"));
};

export const resolveTicketContactAvatar = (ticket) => {
  return resolveContactAvatar(ticket?.contact);
};

/**
 * Handler para suprimir erros 401 (Unauthorized) ao carregar imagens
 * Evita poluir o console com erros de autenticação em imagens
 */
export const handleImageError = (event) => {
  // Suprimir erros 401 (Unauthorized) silenciosamente
  // Esses erros são esperados quando o usuário não está autenticado
  const img = event.target;
  if (img && img.src) {
    // ✅ Verificar se a URL é inválida (contém null ou undefined)
    const src = img.src || '';
    if (src.includes('/null') || src.includes('/undefined') || 
        src === 'null' || src === 'undefined') {
      // URL inválida - substituir imediatamente sem tentar carregar
      img.onerror = null; // Prevenir loop infinito
      img.src = "/nopicture.png";
      return;
    }
    // Se a imagem falhou, substituir por imagem padrão sem gerar erro
    img.onerror = null; // Prevenir loop infinito
    img.src = "/nopicture.png";
  }
};

/**
 * Handler mais robusto que também previne o log no console
 */
export const handleImageErrorSilent = (event) => {
  const img = event.target;
  
  // Prevenir que o erro apareça no console
  event.stopPropagation();
  
  if (img) {
    // Substituir por imagem padrão
    img.onerror = null; // Prevenir loop infinito
    img.src = "/nopicture.png";
  }
};

